import { useFormik } from 'formik';
import { FormGroup } from 'shared-components';
import * as yup from 'yup';
import { Button } from 'shared-components';
import { toast } from 'react-toastify';
import { close } from '../modal/modalSlice';
import { useAppDispatch } from '../../app/hooks';
import { useSendOrderConfirmationEmailMutation } from './orders.api';
import { FormLayout } from 'shared-components';
import { Label } from 'shared-components';
import { Input } from 'shared-components';

export const OrderSendEmailForm = ({
  initialEmail,
  orderId,
}: {
  orderId: string;
  initialEmail?: string;
}) => {
  const dispatch = useAppDispatch();
  const [sendEmail] = useSendOrderConfirmationEmailMutation();

  const { getFieldProps, handleSubmit } = useFormik<{
    to: string;
  }>({
    initialValues: {
      to: initialEmail ?? '',
    },
    validationSchema: yup.object({
      to: yup.string().required().email(),
    }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      await sendEmail({
        ...values,
        id: orderId,
      });
      toast.success('Email confirmation sent!');
      dispatch(close());
    },
  });

  return (
    <form onSubmit={handleSubmit}>
      <FormLayout>
        <FormGroup>
          <Label htmlFor="to">To</Label>
          <Input {...getFieldProps('to')} type="text" id="to" />
        </FormGroup>
        <FormGroup>
          <Button type="submit">Send</Button>
        </FormGroup>
      </FormLayout>
    </form>
  );
};
